import { Component, effect, EventEmitter, Input, Output, SimpleChanges } from "@angular/core";
import { MainModel } from "../../../global/model/MainModel";
import { DonorCardService } from "../../services/donor-card.service";
import { TableModule } from "primeng/table";
import { TableRowCollapseEvent, TableRowExpandEvent } from 'primeng/table';
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { ButtonModule } from "primeng/button";
import { SearchService } from "../../../global/services/data/search-service/searchservice";
import { MessageService } from 'primeng/api';
import { DonationCardService } from "../../services/donation-card.service";
import { Observable } from "rxjs";
import { ChildRow, FundcodesHistory } from "../../models/DonationCardModels";

@Component({
    selector: "app-donor-fund-totals-grid",
    standalone: true,
    imports: [CommonModule, TableModule, FormsModule, ButtonModule],
    providers: [DonorCardService, MessageService],
    templateUrl: './donor-fund-totals-grid.component.html',
    styleUrls: ['./donor-fund-totals-grid.component.scss']
})
export class DonorFundTotalsGridComponent {
    @Input() donorId: string = '';
    @Input() donationId?: number;
    @Input() displayOneModalPopup: boolean = false;
    @Output() fundcodesHistoryLoaded = new EventEmitter<any>();
    fundcodesHistory: FundcodesHistory[] = [];
    expandedRows: { [key: string]: boolean } = {}; // Updated type to allow dynamic keys
    childRowData: { [key: string]: ChildRow[] } = {};
    fullFundcodesHistory: FundcodesHistory[] = [];

    constructor(private mainModel: MainModel,
      private donorCardService: DonorCardService,
      private donationCardService: DonationCardService,
      private messageService: MessageService,
      private searchService: SearchService) {
        effect(() => {
            this.loadFundcodesHistory();
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
      // Reload data if donorId or donationId inputs change
      if (changes['donorId'] || changes['donationId']) {
        this.loadFundcodesHistory();
      }
    }

    loadFundcodesHistory(): void {
      if (this.donationId) {
        this.donationCardService.getFundcodesHistoryByDonation(this.donationId).subscribe({
          next: data => {
            this.fullFundcodesHistory = data.map((item: any) => ({
              ...item,
              isChild: item.isChild === 1, 
              houseHold: item.houseHold === 1 
            }));
            this.fundcodesHistory = this.fullFundcodesHistory.filter((item: any) => item.isChild === false); // Filter where isChild is false
            this.fundcodesHistoryLoaded.emit(this.fullFundcodesHistory);
          },
          error: err => {
            console.error('Error while fetching fundcodes history by donationId: ', err);
            this.fullFundcodesHistory = [];
            this.fundcodesHistory = [];
          }
        });
      } else {
       
        const c: any = this.mainModel.selectedCampaign();
        if (!this.donorId || !c?.campaignId) {
            this.fullFundcodesHistory = [];
            this.fundcodesHistory = [];
            return;
        }
       
        this.donorCardService.getFundcodesHistory(parseInt(c?.campaignId), parseInt(this.donorId)).subscribe({
          next: data => {
            this.fullFundcodesHistory = data.map((item: any) => ({
              ...item,
              isChild: item.isChild === 1, 
              houseHold: item.houseHold === 1 
            }));
            this.fundcodesHistory = this.fullFundcodesHistory.filter((item: any) => item.isChild === false); // Filter where isChild is false
            this.fundcodesHistoryLoaded.emit(this.fullFundcodesHistory);
          },
          error: err => {
            console.error('Error while fetching fundcodes history data by donorId/campaignId: ', err);
            this.fullFundcodesHistory = [];
            this.fundcodesHistory = [];
          }
        });
      }
    }

    expandAll() {
      // Set all fundCodeId keys in expandedRows to true
      this.expandedRows = this.fundcodesHistory.reduce((acc, item) => {
        acc[item.fundCodeId] = true;
        return acc;
      }, {} as { [key: number]: boolean });

      Object.keys(this.expandedRows).forEach((key: string) => {
        const fundCodeId = parseInt(key, 10);
        const fundCodeData = this.fullFundcodesHistory.find(item => item.fundCodeId === fundCodeId);
        if (fundCodeData) {
          // Bind child rows for each expanded row
          if (!this.childRowData[fundCodeId]) {
            const childRows = this.fullFundcodesHistory
              .filter((item: FundcodesHistory) => item.isChild && item.fundCodeId === fundCodeId)
              .map((item: FundcodesHistory) => ({
                name: item.donorName,
                relationship: item.relationshipType,
                amount: item.amount,
                remainingAmount: item.remainingAmount
              } as ChildRow));
            this.childRowData[fundCodeId] = childRows;
          }
        }
      });
    }

    collapseAll() {
        this.expandedRows = {};
    }

    onRowExpand(event: TableRowExpandEvent) {
      const fundcodeHistoryItem = event.data;
      const parentId = fundcodeHistoryItem.fundCodeId;

      // Update expandedRows to expand only the clicked row
      this.expandedRows = { [parentId]: true };

      if (!this.childRowData[parentId]) {
        const childRows = this.fullFundcodesHistory
          .filter((item: FundcodesHistory) => item.isChild && item.fundCodeId === parentId)
          .map((item: FundcodesHistory) => ({
            name: item.donorName,
            relationship: item.relationshipType,
            amount: item.amount,
            remainingAmount: item.remainingAmount
          } as ChildRow));
        this.childRowData[parentId] = childRows;
      }
    }

    onRowCollapse(event: TableRowCollapseEvent) {
      const fundcodeHistoryItem = event.data;
      const parentId = fundcodeHistoryItem.fundCodeId;

      // Remove the collapsed row from expandedRows
      delete this.expandedRows[parentId];
    }

    onClose() {
      this.searchService.emitCloseDonorGivingHistory();
    }

}
